import { batch } from 'react-redux';
import { restoreSalesHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { PMI_REQUEST_FAILURE } from 'src/common/helpers/error-code';
import XLRLogger from 'src/common/helpers/logger';
import { BRMInputActions } from 'src/common/redux/reducers/brm-input-reducer';
import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { TareWeightPercentagesActions } from 'src/common/redux/reducers/tare-weight-percentages-reducer';
import { TbrActions } from 'src/common/redux/reducers/tbr-reducer';
import { TenderExchangeActions } from 'src/common/redux/reducers/tender-exchange-reducer';
import { TransactionSearchActions } from 'src/common/redux/reducers/transaction-search-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import { resetCardData } from 'src/devices/payment/get-card-details';
import { cancelPinpadOperation } from 'src/devices/payment/pinpad-operations';
import { disableScanner } from 'src/devices/scanner-operations';
import { store } from '../../common/redux/configure-store';
import { ItemListActions } from '../../common/redux/reducers/item-list-reducer';
import { MiddleAreaActions } from '../../common/redux/reducers/middle-area-reducer';
import { PinPadActions } from '../../common/redux/reducers/pinpad-reducer';
import { RecallOrderActions } from '../../common/redux/reducers/recall-order-reducer';
import { SalesKeypadActions } from '../../common/redux/reducers/sales-keypad-reducer';
import { SidebarActions } from '../../common/redux/reducers/sidebar-reducer';
import { TareWeightGroupsActions } from '../../common/redux/reducers/tare-weight-groups-reducer';
import { TenderMenuActions } from '../../common/redux/reducers/tender-menu-reducer';
import { TenderingActions } from '../../common/redux/reducers/tendering-reducer';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { endPaymentSession, inPaymentSession } from './../../devices/payment/pinpad-operations';

export const transactionEnd = async (): Promise<void> => {
  // clear redux/UI
  disableScanner();

  batch((): void => {
    store.dispatch(ItemListActions.removeAllRecords());
    store.dispatch(TenderingActions.resetState());
    store.dispatch(TransactionActions.resetState());
    store.dispatch(TenderMenuActions.clearUnPaidPreTender());
    store.dispatch(SidebarActions.showSideBar());
    store.dispatch(MiddleAreaActions.resetState());
    store.dispatch(SalesKeypadActions.resetSalesKeypad());
    store.dispatch(RecallOrderActions.resetState());
    store.dispatch(PinPadActions.resetThirdPartyData());
    store.dispatch(TareWeightGroupsActions.resetTareWeightGroups());
    store.dispatch(TransactionSearchActions.resetState());
    store.dispatch(POSModeActions.resetState());
    store.dispatch(TbrActions.resetState());
    store.dispatch(CustomerDisplayActions.setScreen(CustomerDisplayScreen.IdleScreen));
    store.dispatch(BRMInputActions.resetState());
    store.dispatch(TareWeightPercentagesActions.resetTareWeightPercentages());
    store.dispatch(TenderExchangeActions.setTenderExchangeState(false));
    store.dispatch(TenderExchangeActions.resetTenderExchangeDetails());
  });

  if (store.getState().pinPad.isPinpadConfigured) {
    if (inPaymentSession()) {
      await cancelPinpadOperation()
        .then(endPaymentSession)
        .catch(err => {
          if (err.code !== PMI_REQUEST_FAILURE) {
            XLRLogger.info({
              message: 'Error cancelling request on PIN Pad',
              source: 'transaction-end.ts',
              data: err,
            });
          }
        });
    }
    resetCardData();
  }
  restoreSalesHomePage();
};
